export default __webpack_public_path__ + "static/media/RTLG_card2.b4937e3c.webp";